var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Upload',{attrs:{"action":_vm.url,"on-success":_vm.onsuccess,"on-error":_vm.onerror}},[_c('Button',{attrs:{"icon":"ios-cloud-upload-outline"}},[_vm._v("Upload files")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b0fe894","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/comm/file.vue
// module id = null
// module chunks = 